import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDHeadlineText } from '@facet-wealth/design';

const useStyles = buildUseStyles('ModuleName', (theme) => ({
  root: {
    '& .FD-MuiTypography-root': {
      color: `${theme.palette.primary.main} !important`, // Needed to deal with a temporary hack in the main layout
      fontWeight: theme.typography.fontWeightBold,
    },
  },
}));

const ModuleName = ({ value }) => {
  const classes = useStyles();
  return <div className={classes.root}><FDHeadlineText value={value} size="md" /></div>;
};

ModuleName.defaultProps = {
};

ModuleName.propTypes = {
  value: PropTypes.string.isRequired,
};

export default ModuleName;
